import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiMissionsService } from '../../../../services/missions/api/api-missions.service';
import { AlertsService } from '../../../../services/alerts.service';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-mission-reward-add-modal',
  templateUrl: './mission-reward-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class MissionRewardAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  startDate: string = '';
  endDate: string = '';
  currencyType: number = 0;
  currencyQuantity: number = 0;
  currencyTicketCost: number = 0;
  pointsRequired: number = 0;
  pointsRequiredTotal: number = 0;

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];
  readonly UserCurrencyType = UserCurrencyType;

  private callbackSaved?: () => void;

  constructor(private apiMissionsService: ApiMissionsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.startDate = '';
    this.endDate = '';
    this.currencyType = 0;
    this.currencyQuantity = 0;
    this.currencyTicketCost = 0;
    this.pointsRequired = 0;
    this.pointsRequiredTotal = 0;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    const ticketCost = this.currencyType === UserCurrencyType.MatchTicket ? this.currencyTicketCost : 0;
    this.apiMissionsService.addMissionReward(startTimestamp, endTimestamp, this.currencyType, this.currencyQuantity, ticketCost, this.pointsRequired, this.pointsRequiredTotal).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Mission reward added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding mission reward : ' + error);
      }
    );
  }
}
